import { dynamicFailed } from "../hooks/useToast";
import { IComplaint } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchComplaints = async (): Promise<IComplaint[]> => {
  try {
    const response = await axiosClient.get<IComplaint[]>("/complaints");
    return response.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    return [];
  }
};

